import { clear, unprefix } from '../../../helpers/compact';
import { toText } from '../fields/text';
import { toPosition } from '../mapping/position';
import { author } from './author';

export const quote = (data) => {
  const { txt, position, ...rest } = unprefix('quote', data);
  if (txt) {
    return clear({
      author: author(rest),
      quote: toText(txt),
      position: toPosition(position),
    });
  }
};
